export default __webpack_public_path__ + "static/media/Progressive_Labs_logo-removebg-preview.81995416.png";